/**
 * Shared "is this select control empty?" predicate.
 *
 * Only null, undefined and an empty string count as "no selection". A stored `false`
 * or `0` is a real value (e.g. the Waar/Niet waar picker on boolean filter rows), so
 * plain falsiness must never be used to detect an empty control: doing so skips the
 * initial option resolve and the field renders blank until it gets focus.
 */
export function isEmptyOptionValue(value: unknown): boolean {
  return value == null || value === '';
}
